<template>
    <div>
        <base-alert
            v-if="noRecurringPaymentsSetup"
            type="warning">
            <strong>Uh!</strong> It seems like you don't have automatic payments enabled, you can click
            <router-link to="/profile"><a class="alert-link">here</a></router-link>
            to set them up.
        </base-alert>
        <card card-body-classes="table-full-width">
            <div>
                <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                    <base-input>
                        <el-input
                            type="search"
                            class="mb-3 search-input"
                            clearable
                            prefix-icon="fal fa-search"
                            placeholder="Search records"
                            v-model="searchQuery"
                        >
                        </el-input>
                    </base-input>
                </div>
                <v-data-table id="invoicesTable"
                              :headers="headers" :search="searchQuery"
                              :items="invoices" :loading="isLoadingInvoices"
                              item-key="invoiceID" :pagination.sync="paginationSync"
                              :rows-per-page-items="rowsperpageitems"
                              show-summary data-app
                >
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                        <tr v-bind:class="{'warning': props.item.isExpired && props.item.remaining > 0}">
                            <td>{{ props.item.number }}</td>
                            <td>{{ props.item.date }}</td>
                            <td>{{ props.item.totalFormatted }}</td>
                            <td>{{ props.item.remainingFormatted }}</td>
                            <td>
                                <badge type="info" v-if="props.item.isCreditnote">CREDITNOTE</badge>
                            </td>
                            <td>
                                <badge v-if="props.item.status === 5" type="success">{{ props.item.status_description }}
                                </badge>
                                <badge v-if="props.item.status === 1" type="danger">{{ props.item.status_description }}
                                </badge>
                                <badge v-if="props.item.status === 2" type="warning">{{ props.item.status_description }}
                                </badge>
                                <badge v-if="props.item.status === 6" type="danger">{{ props.item.status_description }}
                                </badge>
                            </td>
                            <td>
                                <base-button
                                    @click.native="handlePDF(props.$index, props.item)"
                                    class="right"
                                    type="info"
                                    size="sm"
                                >
                                    <font-awesome-icon :icon="['fal','file-pdf']"></font-awesome-icon>
                                </base-button>
                                <base-button
                                    v-if="props.item.remaining > 0 && (props.item.status === 1 || props.item.status === 6)"
                                    @click.native="pay(props.$index, props.item)"
                                    type="primary"
                                    class="right"
                                    size="sm"
                                    :loading="paymentLoading.filter(i => i === props.item.ID).length > 0"
                                >
                                    <font-awesome-icon :icon="['fal','credit-card']"></font-awesome-icon>
                                    Pay
                                </base-button>

                            </td>
                        </tr>
                    </template>
                </v-data-table>

            </div>
            <!--<modal :show.sync="showPDF">-->
            <!--<div>-->
            <!--<pdf src="selectedPDF"></pdf>-->
            <!--</div>-->
            <!--<template slot="footer">-->
            <!--<base-button type="secondary" @click="showPDF = false">Close</base-button>-->
            <!--</template>-->
            <!--</modal>-->
        </card>
    </div>

</template>

<script>
    import {Option, Select, Table, TableColumn} from 'element-ui';
    import {BasePagination} from 'src/components';
    import Fuse from 'fuse.js';
    import Badge from "../../components/Badge";
    import Modal from "../../components/Modal";
    import pdf from "vue-pdf";

    export default {
        name: "BillingTable",
        components: {
            pdf,
            Modal,
            Badge,
            BasePagination,
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn
        },
        computed: {
            invoices() {
                return this.$store.getters['billing/invoices'];
            },
            isLoadingInvoices() {
                return this.$store.getters['billing/isLoading'];
            },
            noRecurringPaymentsSetup() {
                return this.$store.getters['customer/hasValidMandate'] === false;
            }
        },
        data() {
            return {
                rowsperpageitems:
                    [5, 10, 25, 50, 100, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],

                paginationSync: {
                    rowsPerPage: 10,
                    descending: true,
                    sortBy: 'number',
                },
                propsToSearch: ['datetime', 'duration', 'destination', 'origin_number', 'origin_device', 'destination_number', 'destination_device'],
                searchedData: [],
                searchQuery: '',
                fuseSearch: null,
                loading: [],
                headers: [
                    {
                        text: 'Number',
                        align: 'left',
                        sortable: true,
                        value: 'number'
                    },
                    {text: 'Date', value: 'date', sortable: true,},
                    {text: 'Total', value: 'totalFormatted'},
                    {text: 'Remaining', value: 'remainingFormatted'},
                    {text: 'Creditnote', value: 'isCreditnote'},
                    {text: 'Status', value: 'status', sortable: true,},
                    {text: 'Actions', align: 'right',},
                ],
                selectedPDF: null,
                showPDF: false,
                paymentLoading: [],
            };
        },
        methods: {
            handlePDF(index, row) {
                this.selectedPDF = row.pdf;
                window.open(this.selectedPDF);
            },

            pay(index, row) {
                let invoice = row.ID;
                this.paymentLoading.push(invoice);


                this.axios({
                    url: this.baseAPIURL + 'invoice/' + invoice + '/pay', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    }, data: {
                        'currentURL': this.$route.fullPath
                    }
                }).then(resp => {
                    this.$store.commit('billing/SET_UPDATE_REQUIRED');
                    this.paymentLoading = this.paymentLoading.filter(i => i !== invoice);
                    window.location = resp.data.paymentURL;
                }).catch(err => {
                })
            },
        },
        mounted() {
            if (this.$store.getters['billing/needUpdate']) {
                this.$store.dispatch('billing/loadInvoices');
            }

            // Fuse search initialization.
            this.fuseSearch = new Fuse(this.invoices, {
                keys: ['ID', 'number', 'date', 'total', 'remaining'],
                threshold: 0.3
            });

        },
        watch: {
            /**
             * Searches through the table data by a given query.
             * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
             * @param value of the query
             */
            searchQuery(value) {
                let result = this.invoices;
                if (value !== '') {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            }
        }
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }

    .el-input__inner {
        padding-left: 30px !important;
    }

    tr.warning {
        background-color: rgba(249, 97, 97, 0.38)
    }
</style>
